import { Component } from "react";
import makeAnimated from "react-select/animated";
import ErrorAlert from "../constantPages/Alerts/ErrorAlert";
import Select from "react-select";
import Societe from "../../services/Societe";
import SocieteService from "../../services/SocieteService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import { Navigate } from "react-router-dom";
import BCService from "../../services/BCService";
import UtilsFormule from "../../utils/UtilsFormule";

class ListSocieteForBC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_message: "",
      idSociete: 0,
      societes: [],
      choiceBC: "",
      choiceDevis: "",
      years: [],
      months: [],
      options: [{ value: 0, label: "Tous" }],
      yearsOptions: [{ value: "00", label: "Tous" }],
      monthsOptions: [{ value: "00", label: "Tous" }],
      selectedOption: null,
      selectedMonth: null,
      selectedYear: null,
      finalYear: "00",
      finalMonth: "00",
      yearPlaceholder: "",
      monthPlaceholder: "",
      payedOrNotPayed: "any",
      redirect: false,
      alert_message_inPayedBill: "",
      alert_message_PayedBill: "",
      alert_message_inPayedBD: "",
      alert_message_PayedBD: "",
      isEmptyPayedBills: false,
      isEmptyNotPayedBills: false,
      isEmptyBDCBills: false,
      bills: [],
      BC: [],
      billPayed: [],

    };
    this.remplissageYearsAndMonthsOption =
      this.remplissageYearsAndMonthsOption.bind(this);
    this.onchoosePayedHandler = this.onchoosePayedHandler.bind(this);
    this.onchooseNotPayedHandler = this.onchooseNotPayedHandler.bind(this);
    this.onchooseAllPayementHandler =
      this.onchooseAllPayementHandler.bind(this);
    this.onchooseNotPayedHandler = this.onchooseNotPayedHandler.bind(this);
    this.handleYearChange = this.handleYearChange.bind(this);
    this.handleMonthChange = this.handleMonthChange.bind(this);
  }

  componentDidMount() {
    this.forceUpdate();
    SocieteService.getFinacialYearsAndMonthsFromSocieteCreationDate(
      getCurrentUserId()
    )
      .then((response) => {
        if (response.data["success"] !== undefined) {
          this.setState({ years: response.data["success"].years });
          this.setState({ months: response.data["success"].months });

          console.log("response", response);
          //   this.setState({ alert_message: "success" });
          this.remplissageYearsAndMonthsOption();
        }
      })
      .catch((error) => {
        //  this.setState({ alert_message: "error" });
      });
    Societe.getSocietesClients(
      this.props.typeSociete,
      this.props.typeClient,
      1,
      0
    )
      .then((response) => {
        if (response.data["Societe"] === "erreur") {
          this.setState({ alert_message: "error" });
        } else {
          this.setState({ societes: response.data["Societe"] });
          this.setState({ alert_message: "success" });
          this.remplissageOptions();
        }
      })
      .catch((error) => {
        this.setState({ alert_message: "error" });
      });
  }

  saveIdSociete = (e) => {
    localStorage.setItem("finalMonth", this.state.finalMonth);
    localStorage.setItem("finalYear", this.state.finalYear);
    localStorage.setItem("isIncome", this.props.isIncome);
    if (this.state.idSociete === "") {
      this.setState({ alert_message: "error choice" });
    } else {
      BCService.getBonDeCommandeByFilterForPayementTask(
        getCurrentUserId(), localStorage.getItem("idSociete"),
        localStorage.getItem("finalMonth"),
        localStorage.getItem("finalYear")
      )
        .then((response) => {
          if (response.data["success"] !== undefined) {
            this.setState({ BC: response.data["success"] });
          } else if (response.data["empty"] !== undefined) {
            this.setState({ isEmptyBDCBills: true });
          }
        })
        .catch((error) => {
          this.setState({ alert_message: "error" });

          this.setState({ alert_message_inPayedBD: "error" });
        });

    }

    e.preventDefault();
  };
  handleChange = (selectedOption) => {
    this.setState({ selectedOption }, () =>
      console.log(`Option selected:`, this.state.selectedOption)
    );
    this.setState({ idSociete: selectedOption.value });
    console.log("idSociete", this.state.idSociete);
  };

  remplissageOptions() {
    this.state.societes.map((typeBill) => {
      if (typeBill !== null) {
        this.setState({
          options: [
            ...this.state.options,
            { value: typeBill.id, label: typeBill.title },
          ],
        })
      }
    }
    );
  }
  onChangeBonCommande(e) {
    this.setState({ choiceBC: e.target.value });
    console.log(e.target.value);
  }

  handleYearChange = (selectedYear) => {
    this.setState({ yearPlaceholder: selectedYear.label })

    this.setState({ finalYear: selectedYear.value });
  };

  handleMonthChange = (selectedMonth) => {
    this.setState({ monthPlaceholder: selectedMonth.label })

    this.setState({ finalMonth: selectedMonth.value });
  };

  remplissageYearsAndMonthsOption() {
    var today = new Date();
    var mm = String(today.getMonth() + 1).padStart(2, "0");
    var yyyy = today.getFullYear();
    this.setState({ finalYear: yyyy });
    this.setState({ yearPlaceholder: yyyy });
    if (mm === "01") {
      this.setState({ finalMonth: "01" });
      this.setState({ monthPlaceholder: "Janvier" });
    } else if (mm === "02") {
      this.setState({ finalMonth: "02" });
      this.setState({ monthPlaceholder: "Février" });
    } else if (mm === "03") {
      this.setState({ finalMonth: "03" });
      this.setState({ monthPlaceholder: "Mars" });
    } else if (mm === "04") {
      this.setState({ finalMonth: "04" });
      this.setState({ monthPlaceholder: "Avril" });
    } else if (mm === "05") {
      this.setState({ finalMonth: "05" });
      this.setState({ monthPlaceholder: "Mai" });
    } else if (mm === "06") {
      this.setState({ finalMonth: "06" });
      this.setState({ monthPlaceholder: "Juin" });
    } else if (mm === "07") {
      this.setState({ finalMonth: "07" });
      this.setState({ monthPlaceholder: "Juiliet" });
    } else if (mm === "08") {
      this.setState({ finalMonth: "08" });
      this.setState({ monthPlaceholder: "Aout" });
    } else if (mm === "09") {
      this.setState({ finalMonth: "09" });
      this.setState({ monthPlaceholder: "Septembre" });
    } else if (mm === "10") {
      this.setState({ finalMonth: "10" });
      this.setState({ monthPlaceholder: "Octobre" });
    } else if (mm === "11") {
      this.setState({ finalMonth: "11" });
      this.setState({ monthPlaceholder: "Novembre" });
    } else if (mm === "12") {
      this.setState({ finalMonth: "12" });
      this.setState({ monthPlaceholder: "Decemebre" });
    }

    this.state.years.map((year, index) =>
      this.setState({
        yearsOptions: [
          ...this.state.yearsOptions,
          { value: year, label: year },
        ],
      })
    );

    let orderedMonth = [];

    this.state.months.map((month, index) => orderedMonth.push(parseInt(month)));
    orderedMonth.sort(function (a, b) {
      return a - b;
    });
    orderedMonth.map((month, index) => {
      if (month === 1) {
        this.setState({
          monthsOptions: [
            ...this.state.monthsOptions,
            { value: "01", label: "Janvier" },
          ],
        });
      } else if (month === 2) {
        this.setState({
          monthsOptions: [
            ...this.state.monthsOptions,
            { value: "02", label: "Février" },
          ],
        });
      } else if (month === 3) {
        this.setState({
          monthsOptions: [
            ...this.state.monthsOptions,
            { value: "03", label: "Mars" },
          ],
        });
      } else if (month === 4) {
        this.setState({
          monthsOptions: [
            ...this.state.monthsOptions,
            { value: "04", label: "Avril" },
          ],
        });
      } else if (month === 5) {
        this.setState({
          monthsOptions: [
            ...this.state.monthsOptions,
            { value: "05", label: "Mai" },
          ],
        });
      } else if (month === 6) {
        this.setState({
          monthsOptions: [
            ...this.state.monthsOptions,
            { value: "06", label: "Juin" },
          ],
        });
      } else if (month === 7) {
        this.setState({
          monthsOptions: [
            ...this.state.monthsOptions,
            { value: "07", label: "Juillet" },
          ],
        });
      } else if (month === 8) {
        this.setState({
          monthsOptions: [
            ...this.state.monthsOptions,
            { value: "08", label: "Aout" },
          ],
        });
      } else if (month === 9) {
        this.setState({
          monthsOptions: [
            ...this.state.monthsOptions,
            { value: "09", label: "Septembre" },
          ],
        });
      } else if (month === 10) {
        this.setState({
          monthsOptions: [
            ...this.state.monthsOptions,
            { value: "10", label: "Octobre" },
          ],
        });
      } else if (month === 11) {
        this.setState({
          monthsOptions: [
            ...this.state.monthsOptions,
            { value: "11", label: "Novembre" },
          ],
        });
      } else if (month === 12) {
        this.setState({
          monthsOptions: [
            ...this.state.monthsOptions,
            { value: "12", label: "Decembre" },
          ],
        });
      }

    });
  }

  onchoosePayedHandler = () => {
    this.state.payedOrNotPayed = 1;
  };

  onchooseNotPayedHandler = () => {
    this.state.payedOrNotPayed = 0;
  };

  onchooseAllPayementHandler = () => {
    this.state.payedOrNotPayed = "any";
  };
  avanceLink() {
    return <Navigate replace to="/payerAvanceBC" />
  }
  factureLink() {
    return <Navigate replace to="/addBCBillAchat" />
  }
  detailsLink() {

    return <Navigate replace to="/payerAvanceBC" />
  }

  listBonCommandes() {
    if (this.state.BC.length === 0) {
      return <div class="col-md-12"></div>;
    } else {
      return (
        <section class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">
                  <h3 class="card-title">Les Bon de commandes</h3>
                </div>
                <div class="card-body p-0">
                  <table class="table table-striped table-bordered table-sm">
                    <thead>
                      <tr className="text-center">
                        <th>Référence</th>
                        <th>Titre</th>
                        <th>Fournisseur</th>
                        <th>DC</th>

                        <th>Prix TTC</th>
                        <th>Payé</th>
                        <th>Avance</th>

                        <th>Facture</th>
                        <th>Détails </th>
                        <th>Archiver</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.BC.map((bcom) => (
                        <tr>
                          <td>
                            {bcom.refBC}/{bcom.yearRefBC}
                          </td>
                          <td>
                            {bcom.title}
                          </td>
                          <td> {bcom.societeCliente.title}</td>
                          <td> {UtilsFormule.formatDate(bcom.creationDate)}</td>

                          <td> {bcom.amountTT}DNT </td>
                          <td> {bcom.amountPayed}DNT </td>
                          <td className="text-center">
                            <button
                              style={{ width: 40 }}
                              type="submit"
                              onClick={() => {
                                localStorage.setItem("idBC", bcom.id);
                                this.avanceLink()

                              }}
                              class="btn bg-gray btn-sm"
                            >
                              <i class="fas fa-plus"></i>
                            </button>
                          </td>
                          <td className="text-center">
                            <button
                              style={{ width: 40 }}

                              type="submit"
                              onClick={() => {
                                localStorage.setItem("idBC", bcom.id);
                                this.factureLink()
                              }}
                              class="btn bg-gray-dark btn-sm"
                            >
                              <i class="fas fa-plus"></i>
                            </button>
                          </td>
                          <td className="text-center">
                            <button
                              type="submit"
                              onClick={() => {
                                localStorage.setItem(
                                  "idBC",
                                  bcom.id
                                );
                                this.detailsLink()
                              }}
                              class="btn bg-black btn-sm"
                            >
                              <i class="fas fa-shopping-cart"></i>
                            </button>
                          </td>

                          <td className="text-center">

                            <button
                              style={{ width: 40 }}

                              class="btn btn-danger btn-sm"
                              onClick={(e) => {
                                if (
                                  window.confirm(
                                    "Voulez vous supprimer le bon de commande? "
                                  )
                                ) {
                                  this.deleteBC(bcom.bonCommande.id);
                                }
                              }}>
                              <i class="fas fa-trash"></i>

                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section >
      );
    }
  }

  render() {
    const animatedComponents = makeAnimated();
    const { selectedOption } = this.state;
    const { selectedMonth } = this.state;
    const { selectedYear } = this.state;
    if (this.state.redirect) {
      return <Navigate replace to="/listBCValidated" />;
    } else {
      if (this.state.alert_message === "error") {
        return (
          <div className="content-wrapper">
            <section class="content">
              <div class="row">
                <div class="col-md-12">
                  <ErrorAlert message="Désolé aucun Société Fournisseurs à afficher, Vous devez ajouter une société svp" />
                </div>
              </div>
            </section>
          </div>
        );
      } else if (this.state.alert_message === "error choice") {
        return (
          <div className="content-wrapper" style={{ marginTop: "0" }}>
            <section class="content">
              <div class="row">
                <div class="col-md-12">
                  <ErrorAlert message="Vous devez choisir un des fournisseurs de la liste" />
                </div>
              </div>

              <div class="card ">

                <form
                  className="form-horizontal"
                  onSubmit={this.saveIdSociete}
                ></form>

                <div className="card-body">
                  <div class="row">
                    <div class="form-group col-4 col-sm-4">
                      <label>Choisir le fournisseur </label>
                      <Select
                        value={this.state.selectedOption}
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        options={this.state.options}
                        onChange={this.handleChange}
                        defaultValue={selectedOption}
                        placeholder={"Tous"}
                      />
                    </div>
                    <div class="form-group col-4 col-sm-4">
                      <div>
                        <label>Choisir l'année </label>
                        <Select
                          value={this.state.selectedYear}
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          options={this.state.yearsOptions}
                          onChange={this.handleYearChange}
                          // defaultValue={selectedYear}
                          placeholder={this.state.yearPlaceholder}
                        />
                      </div>
                    </div>
                    <div class="form-group col-4 col-sm-4">
                      <div>
                        <label>Choisir le mois</label>
                        <Select
                          value={this.state.selectedMonth}
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          options={this.state.monthsOptions}
                          onChange={this.handleMonthChange}
                          defaultValue={selectedMonth}
                          placeholder={this.state.monthPlaceholder}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="col-sm-12  text-center">
                    <button
                      type="submit"
                      onClick={this.saveIdSociete}
                      className="btn btn-dark"
                    >
                      Valider
                    </button>
                  </div>
                </div>
              </div>
            </section>
            {this.listBonCommandes()}

          </div>
        );
      } else {
        return (
          <div className="content-wrapper" style={{ marginTop: "0" }}>
            <section class="content">
              <div class="row">
                <div class="col-md-12">
                  <br />
                  <div class="card ">

                    <form
                      className="form-horizontal"
                      onSubmit={this.saveIdSociete}
                    ></form>

                    <div className="card-body">
                      <div class="row">
                        <div class="form-group col-4 col-sm-4">
                          <label>Choisir le fournisseur </label>
                          <Select
                            value={this.state.selectedOption}
                            closeMenuOnSelect={true}
                            components={animatedComponents}
                            options={this.state.options}
                            onChange={this.handleChange}
                            defaultValue={selectedOption}
                            placeholder={"Tous"}
                          />
                        </div>
                        <div class="form-group col-4 col-sm-4">
                          <div>
                            <label>Choisir l'année </label>
                            <Select
                              value={this.state.selectedYear}
                              closeMenuOnSelect={true}
                              components={animatedComponents}
                              options={this.state.yearsOptions}
                              onChange={this.handleYearChange}
                              defaultValue={selectedYear}
                              placeholder={this.state.yearPlaceholder}
                            />
                          </div>
                        </div>
                        <div class="form-group col-4 col-sm-4">
                          <div>
                            <label>Choisir le mois</label>
                            <Select
                              value={this.state.selectedMonth}
                              closeMenuOnSelect={true}
                              components={animatedComponents}
                              options={this.state.monthsOptions}
                              onChange={this.handleMonthChange}
                              defaultValue={selectedMonth}
                              placeholder={this.state.monthPlaceholder}
                            />
                          </div>
                        </div>

                      </div>
                    </div>
                    <div className="card-footer">
                      <div className="col-sm-12  text-center">

                        <button
                          type="submit"
                          onClick={this.saveIdSociete}
                          className="btn btn-dark"
                        >
                          Valider
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {this.listBonCommandes()}

          </div>
        );
      }
    }
  }
}
export default ListSocieteForBC;
